import {AxiosPromise} from 'axios';

import {CMS_BANNER} from 'constants/actions';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';
import {ActionType} from '@typescript/common/actionTypes';
import {getCloudinaryPrefix} from 'libs/cloudinary/cloudinary';

/**
 * Get CMS block by ID
 *
 * @param {string} place - CMS block placeholder
 * @param {string} affId - CMS block affiliate id
 * @param {string} bannerName - Banner name
 * @returns {ActionType<AxiosPromise>} - Action
 */
export function getCmsByAffId(
    place: string,
    affId: string,
    bannerName = '',
): ActionType<AxiosPromise> {
    return {
        type: 'GET_CMS_BLOCK_BY_ID',
        payload: instanceGusaBackend({
            method: 'get',
            url: `${
                ENDPOINTS.CMS_GET_BY_PLACEHOLDER
            }/${place}?url_prefix=${getCloudinaryPrefix()}&affid=${affId}`,
        }),
        meta: {bannerName},
    };
}

/**
 * Get CMS block by ID
 *
 * @param {{
        bannerId: string,
        withPopup: boolean,
        affId: string,
    }} arguments - CMS block id, withPopup flag, current affId.
 * @param {{bannerName: string}} meta - Meta information.
 * @returns {ActionType<AxiosPromise>} - Action
 */
export function getCmsByApi(
    {
        bannerId,
        withPopup = false,
        affId = '',
    }: {
        bannerId: string;
        withPopup?: boolean;
        affId?: string;
    },
    meta: {bannerName?: string} = {},
): ActionType<AxiosPromise> {
    return {
        type: 'GET_CMS_BLOCK_BY_ID',
        payload: instanceGusaBackend({
            method: 'get',
            url: `${ENDPOINTS.CMS_GET_BY_ID}/${bannerId}?url_prefix=${getCloudinaryPrefix()}${
                withPopup ? '&with_popup=1' : ''
            }${affId ? `&aff_id=${affId}` : ''}`,
        }),
        meta,
    };
}

/**
 * Get custom popup
 * @param {string} id - id block
 * @param {{}} params - params
 * @returns {ActionType<AxiosPromise>} - Action
 */
export function getCustomPopup(id: string, params: {}): ActionType<AxiosPromise> {
    let data = '';

    Object.keys(params).forEach((item: string) => {
        data += `&${item}=${params[item]}`;
    });

    return {
        type: 'GET_CUSTOM_POPUP',
        payload: instanceGusaBackend({
            method: 'get',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            url: `${
                ENDPOINTS.CMS_GET_CUSTOM_POPUP
            }?url_prefix=${getCloudinaryPrefix()}&block_id=${id}${data}`,
            data,
        }),
    };
}

/**
 * Get custom popup
 * @param {{placeholder: string, bannerId: string}} bannerData - with banner id or placeholder
 * @returns {ActionType<{}>} - Action
 */
export function startBannerSaga(bannerData: {
    placeholder?: string;
    bannerId?: string;
}): ActionType<{}> {
    return {
        type: CMS_BANNER.START_SAGA_BANNER,
        payload: bannerData,
    };
}

/**
 * Get cms popup content
 * @param {string} placeholder - placeholder of cms popup
 * @param {string} blockName - name of cms popup
 * @returns {ActionType<{}>} - Action
 */
export const getCmsPopupContent = (placeholder: string, blockName: string): ActionType<{}> => ({
    type: CMS_BANNER.GET_POPUP,
    payload: {
        placeholder,
        blockName,
    },
});
